import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';
import { SWAlertService } from '../../services/swalert.service';

@Component({
  selector: 'app-forgetpassword',
  templateUrl: './forgetpassword.component.html',
  styleUrls: ['./forgetpassword.component.css']
})
export class ForgetpasswordComponent implements OnInit {
  ForgetPasswordForm: FormGroup;//สร้างกลุ่ม Object Data

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private System: TSFuntionService,
    private http: HttpClient,
    private Swal: SWAlertService
  ) { }

  ngOnInit() {
    //this.System.OnFocus("txtUserName", "btnLogin");
    this.ForgetPasswordForm = this.formBuilder.group({
      search: ["",[Validators.required]]
    });
  }

  //#region Validate
  isFieldValid(field: string) {
    return !this.ForgetPasswordForm.get(field).valid && this.ForgetPasswordForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  //#endregion

  //#region Button Submit
  onSubmit() {
    let _this = this;
    if (this.ForgetPasswordForm.invalid) {
      this.validateAllFormFields(this.ForgetPasswordForm); //{7}
      return;
    } else {
      this.System.BlockUI();
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let formObj = this.ForgetPasswordForm.getRawValue(); // 
      let ITEM = JSON.stringify(formObj);
      this.http.post(this.System.SiteName + "api/_System/_ForgetPassword", ITEM, { headers, responseType: 'text' }).subscribe(res => {
        if (res)
        {
          this.System.UnBlockUI();
          if (res == "Success") {
            this.Swal.SwAlert.Success(this.Swal.BoxMsg.Title_Success, this.Swal.BoxMsg.Desc_Success_Sent_Email, function () { _this.router.navigate(["/login"]); });
            //this.router.navigate(["/login"]);
          } else {
            this.Swal.SwAlert.Error(this.Swal.BoxMsg.Title_Warning, this.Swal.BoxMsg.Desc_Error_Incorrect , function () { Swal.close(); });
          }
        }
      });
    }
  }
  //#endregion

  //#region Button Back
  Back() {
    this.router.navigate(["/login"]);
  }
  //#endregion
}
